import { CameraIcon } from "@heroicons/react/24/solid";
import { Trans, useLingui } from "@lingui/react/macro";

import { FORM_NAME, useUpdateMyInfo } from "~/hook/overlay/useUpdateMyInfo.ts";
import { WebModalNavigation } from "~/ui/base/Navigation.tsx";
import { createWebStackedPage } from "~/ui/base/WebStackedPage.tsx";

export const WebUpdateMyInfoStack = createWebStackedPage(
  ({ close, titleId }) => {
    const { t } = useLingui();
    const {
      data,
      formRef,
      handleImageChange,
      handleNameChange,
      handleSubmit,
      isMutating,
    } = useUpdateMyInfo(close);

    return (
      <div className="flex flex-col">
        <WebModalNavigation
          left={{
            disabled: isMutating,
            label: t`취소`,
            onClick: close,
          }}
          right={{
            disabled: isMutating,
            label: t`완료`,
            onClick: handleSubmit,
          }}
          title={t`프로필 편집`}
          titleId={titleId}
        />
        <form
          className="flex flex-col gap-6 p-6 sm:p-8"
          onSubmit={(e) => {
            e.preventDefault();
          }}
          ref={formRef}
        >
          <div className="flex justify-center py-2">
            <label className="group relative flex cursor-pointer flex-col items-center gap-3">
              <div className="relative">
                <img
                  alt={t`프로필 이미지`}
                  className="h-24 w-24 rounded-full bg-zinc-100 object-cover ring-2 ring-zinc-200/80 dark:bg-zinc-800 dark:ring-zinc-800"
                  src={
                    data.profileImageUrl ?? "/asset/default_user_profile.png"
                  }
                />
                <div className="absolute inset-0 flex items-center justify-center rounded-full bg-black/30 opacity-0 transition-opacity group-hover:opacity-100">
                  <CameraIcon className="size-6 text-white" />
                </div>
                <div className="absolute right-0 bottom-0 flex size-7 items-center justify-center rounded-full bg-zinc-900 text-white shadow-md dark:bg-zinc-100 dark:text-zinc-900">
                  <CameraIcon className="size-4" />
                </div>
              </div>
              <p className="text-xs font-medium text-zinc-500 group-hover:text-zinc-800 dark:text-zinc-400 dark:group-hover:text-zinc-200">
                <Trans>사진 수정</Trans>
              </p>
              <input
                accept="image/png,image/jpg,image/jpeg"
                className="hidden"
                id="profileImage"
                name={FORM_NAME.PROFILE_IMAGE}
                onChange={(e) => {
                  handleImageChange(e.target.files?.item(0) ?? undefined);
                }}
                type="file"
              />
            </label>
          </div>
          <div
            className="grid items-center gap-4 pt-2 text-sm"
            style={{ gridTemplateColumns: "80px 1fr" }}
          >
            <label
              className="font-medium text-zinc-700 dark:text-zinc-300"
              htmlFor="name"
            >
              <Trans>이름</Trans>
            </label>
            <input
              className="w-full rounded-lg border border-zinc-200 bg-zinc-50/50 px-3 py-2 text-zinc-800 transition-colors outline-none focus:border-zinc-400 focus:bg-white dark:border-zinc-800 dark:bg-zinc-900/50 dark:text-zinc-100 dark:focus:border-zinc-600 dark:focus:bg-zinc-900"
              id="name"
              onChange={({ target: { value: name } }) => {
                handleNameChange(name);
              }}
              type="text"
              value={data.name}
            />
          </div>
        </form>
      </div>
    );
  },
);
